import React from 'react'
import Cleave from 'cleave.js/react'

require('cleave.js/dist/addons/cleave-phone.us')

function PhoneField(field) {
  return (
    <Cleave
      options={{ phone: true, phoneRegionCode: 'US', delimiter: '-' }}
      value={field.value}
      name={field.name}
      onChange={e => {
        const tmp = e
        tmp.target.value = e.target.value.replace(/\s/g, '')
        field.onChange(tmp)
      }}
      onBlur={e => field.onBlur(e)}
      className="form__input"
      id="phone"
      required
    />
  )
}

export default PhoneField
